import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { checkIfPermitted } from "../services/RolePermissionService";
import Permissions from "../utils/PermissionKeys.json"
import history from "../utils/history";

const AuthenticationRoute = ({component: Component, keyObj, ...rest}) => {
   
   let loggedIn = !!(JSON.parse(localStorage.getItem("USER_INFO")) && 
   JSON.parse(localStorage.getItem("USER_INFO")).token);
  // console.log("loggedIn", loggedIn)
    return (
      <Route
        {...rest}
        render={(props) => loggedIn === true
          ? <Component {...props} />
          : <Redirect to={{pathname: '/app/access-denied', state: {from: props.location}}} />}
      />
    )
  }

  export default AuthenticationRoute;